module.exports = __webpack_public_path__ + "img/paperclip_white.95a4e2e0.png";